import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { handleHashScroll } from '../utils/scrollUtils';

const ServicesPage = () => {
  useEffect(() => {
    handleHashScroll();
  }, []);

  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero" style={{minHeight: '60vh', paddingTop: 'calc(80px + var(--spacing-xl))'}}>
        <div className="container hero-content">
          <span className="section-label">What We Offer</span>
          <h1>Our Services</h1>
          <p>Comprehensive IT solutions tailored to drive your business forward with cutting-edge technology and expert execution.</p>
        </div>
      </section>

      {/* Custom Software Solutions */}
      <section id="custom-software" className="section">
        <div className="container">
          <div className="grid grid-2" style={{alignItems: 'center', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left">
              <span className="section-label">Service 01</span>
              <h2>Custom Software Solutions</h2>
              <p style={{fontSize: '1.125rem', marginTop: 'var(--spacing-md)'}}>
                Transform your unique business challenges into opportunities with tailor-made software solutions. Our team specializes in creating enterprise-grade applications that scale with your business.
              </p>
              
              <h4 style={{marginTop: 'var(--spacing-md)', color: 'var(--color-white)'}}>What We Deliver:</h4>
              <ul style={{listStyle: 'none', padding: 0, margin: 'var(--spacing-sm) 0'}}>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Enterprise Application Development</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Mobile App Development (iOS & Android)</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ System Integration & API Development</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Cloud-Native Applications</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Legacy System Modernization</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Microservices Architecture</li>
              </ul>
              
              <div style={{marginTop: 'var(--spacing-md)'}}>
                <Link to="/contact" className="btn btn-primary">Start Your Project</Link>
              </div>
            </div>
            
            <div className="reveal-right">
              <div className="card" style={{padding: 'var(--spacing-xl)', background: 'linear-gradient(135deg, var(--color-black-light), var(--color-black-lighter))'}}>
                <h4 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Technologies We Use</h4>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 'var(--spacing-sm)'}}>
                  {['React', 'Node.js', 'Python', '.NET', 'Java', 'Flutter', 'React Native', 'AWS', 'Azure', 'Docker', 'Kubernetes'].map(tech => (
                    <span key={tech} style={{backgroundColor: 'var(--color-black-lighter)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.875rem', color: 'var(--color-gray)'}}>{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Website & Web App Development */}
      <section id="web-development" className="section" style={{backgroundColor: '#0F0F0F'}}>
        <div className="container">
          <div className="grid grid-2" style={{alignItems: 'center', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left" style={{order: 2}}>
              <span className="section-label">Service 02</span>
              <h2>Website & Web App Development</h2>
              <p style={{fontSize: '1.125rem', marginTop: 'var(--spacing-md)'}}>
                Create stunning digital experiences that captivate users and drive results. From corporate websites to complex web applications, we build responsive, performant, and beautiful web solutions.
              </p>
              
              <h4 style={{marginTop: 'var(--spacing-md)', color: 'var(--color-white)'}}>What We Build:</h4>
              <ul style={{listStyle: 'none', padding: 0, margin: 'var(--spacing-sm) 0'}}>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Corporate Websites & Landing Pages</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ E-commerce Platforms</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Web Portals & Dashboards</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Progressive Web Apps (PWA)</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Content Management Systems</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Single Page Applications (SPA)</li>
              </ul>
              
              <div style={{marginTop: 'var(--spacing-md)'}}>
                <Link to="/contact" className="btn btn-primary">Get a Quote</Link>
              </div>
            </div>
            
            <div className="reveal-right" style={{order: 1}}>
              <div className="card" style={{padding: 'var(--spacing-lg)'}}>
                <h4 style={{color: 'var(--color-white)', marginBottom: 'var(--spacing-md)'}}>Our Process</h4>
                <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)'}}>
                  {[
                    {num: '1', title: 'Discovery & Planning', desc: 'Understanding your goals and requirements'},
                    {num: '2', title: 'Design & Prototyping', desc: 'Creating beautiful, user-centric designs'},
                    {num: '3', title: 'Development & Testing', desc: 'Building with best practices and quality assurance'},
                    {num: '4', title: 'Launch & Support', desc: 'Deployment and ongoing maintenance'}
                  ].map(step => (
                    <div key={step.num} style={{display: 'flex', alignItems: 'start', gap: 'var(--spacing-sm)'}}>
                      <div style={{minWidth: '40px', height: '40px', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'white'}}>{step.num}</div>
                      <div>
                        <h5 style={{color: 'var(--color-white)', marginBottom: '0.25rem'}}>{step.title}</h5>
                        <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>{step.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Data Analytics & BI */}
      <section id="data-analytics" className="section">
        <div className="container">
          <div className="grid grid-2" style={{alignItems: 'center', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left">
              <span className="section-label">Service 03</span>
              <h2>Data Analytics & Business Intelligence</h2>
              <p style={{fontSize: '1.125rem', marginTop: 'var(--spacing-md)'}}>
                Turn data into your competitive advantage. We help you collect, analyze, and visualize data to make informed decisions that drive business growth.
              </p>
              
              <h4 style={{marginTop: 'var(--spacing-md)', color: 'var(--color-white)'}}>Our Expertise:</h4>
              <ul style={{listStyle: 'none', padding: 0, margin: 'var(--spacing-sm) 0'}}>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Interactive Dashboards & Reports</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Data Visualization & Infographics</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Predictive Analytics & Forecasting</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Data Warehouse Solutions</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ ETL Process Development</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Machine Learning Integration</li>
              </ul>
              
              <div style={{marginTop: 'var(--spacing-md)'}}>
                <Link to="/contact" className="btn btn-primary">Discover Insights</Link>
              </div>
            </div>
            
            <div className="reveal-right">
              <div className="card" style={{padding: 'var(--spacing-xl)'}}>
                <h4 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Analytics Tools</h4>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 'var(--spacing-sm)'}}>
                  {['Power BI', 'Tableau', 'SQL Server', 'Python', 'R', 'Apache Spark', 'MongoDB', 'Elasticsearch'].map(tech => (
                    <span key={tech} style={{backgroundColor: 'var(--color-black-lighter)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.875rem', color: 'var(--color-gray)'}}>{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SharePoint Solutions */}
      <section id="sharepoint" className="section" style={{backgroundColor: '#0F0F0F'}}>
        <div className="container">
          <div className="grid grid-2" style={{alignItems: 'center', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left" style={{order: 2}}>
              <span className="section-label">Service 04</span>
              <h2>SharePoint Solutions</h2>
              <p style={{fontSize: '1.125rem', marginTop: 'var(--spacing-md)'}}>
                Streamline collaboration and boost productivity with powerful SharePoint solutions. Transform how your organization works together with custom intranets, document management, and workflow automation.
              </p>
              
              <h4 style={{marginTop: 'var(--spacing-md)', color: 'var(--color-white)'}}>What We Offer:</h4>
              <ul style={{listStyle: 'none', padding: 0, margin: 'var(--spacing-sm) 0'}}>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Intranet Portal Development</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Document Management Systems</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Workflow Automation</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ SharePoint Migration Services</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Custom Web Parts & Apps</li>
                <li style={{padding: '0.5rem 0', color: 'var(--color-gray)'}}>✓ Training & Support</li>
              </ul>
              
              <div style={{marginTop: 'var(--spacing-md)'}}>
                <Link to="/contact" className="btn btn-primary">Transform Your Workplace</Link>
              </div>
            </div>
            
            <div className="reveal-right" style={{order: 1}}>
              <div className="card" style={{padding: 'var(--spacing-lg)'}}>
                <h4 style={{color: 'var(--color-white)', marginBottom: 'var(--spacing-md)'}}>Key Benefits</h4>
                <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)'}}>
                  {[
                    {title: 'Enhanced Collaboration', desc: 'Seamless teamwork across departments'},
                    {title: 'Centralized Content', desc: 'All documents in one secure location'},
                    {title: 'Automated Workflows', desc: 'Streamline repetitive processes'},
                    {title: 'Mobile Access', desc: 'Work from anywhere, anytime'}
                  ].map((benefit, i) => (
                    <div key={i} style={{display: 'flex', alignItems: 'start', gap: 'var(--spacing-sm)'}}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{minWidth: '24px', color: 'var(--color-blue-light)', marginTop: '0.25rem'}}>
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <div>
                        <h5 style={{color: 'var(--color-white)', marginBottom: '0.25rem'}}>{benefit.title}</h5>
                        <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>{benefit.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
